import { EnrolmentRoute } from "@/constants/routes/enrolment.ts"
import { Layouts } from "@/types/Layout"
import { Component } from "vue"
import { RouteRecordRaw } from "vue-router"

import EnrolmentAddress from "@/views/enrolment/EnrolmentAddress.vue"
// Eagerly loaded views
import EnrolmentContainer from "@/views/enrolment/EnrolmentContainer.vue"

export const enrolmentWebRoutes = [
  {
    path: EnrolmentRoute.enrolment,
    component: EnrolmentContainer,
    meta: {
      layout: Layouts.EMPTY,
      requiresAuth: false,
    },
    children: [
      {
        path: EnrolmentRoute.enrolment,
        redirect: EnrolmentRoute.enrolmentAddress,
      },
      {
        path: EnrolmentRoute.enrolmentAddress,
        component: EnrolmentAddress,
      },
      {
        path: EnrolmentRoute.enrolmentProperty,
        component: (): Promise<Component> =>
          import("@/views/enrolment/EnrolmentProperty.vue"),
      },
      {
        path: EnrolmentRoute.enrolmentTariff,
        component: (): Promise<Component> =>
          import("@/views/enrolment/EnrolmentTariff.vue"),
      },
      {
        path: EnrolmentRoute.enrolmentPersonalDetails,
        component: (): Promise<Component> =>
          import("@/views/enrolment/EnrolmentPersonalDetails.vue"),
      },
      {
        path: EnrolmentRoute.enrolmentPayment,
        component: (): Promise<Component> =>
          import("@/views/enrolment/EnrolmentPayment.vue"),
      },
      {
        path: EnrolmentRoute.enrolmentReview,
        component: (): Promise<Component> =>
          import("@/views/enrolment/EnrolmentReview.vue"),
      },
    ],
  },
  {
    path: EnrolmentRoute.enrolmentComplete,
    component: (): Promise<Component> =>
      import("@/views/enrolment/EnrolmentComplete.vue"),
  },
] satisfies readonly RouteRecordRaw[]
